// src/data/students.ts
// Dados dos alunos - as URLs são resolvidas pelo imageService
import { getImageUrl } from '../services/imageService';

// Tipo do aluno
export interface StudentData {
    id: number;
    name: string;
    favoriteQuote: string;
    favoriteSong: string;
    photo: string; // filename apenas
    githubLink?: string;
    linkedinLink?: string;
}

// Pasta onde as fotos dos alunos estão armazenadas
const STUDENTS_FOLDER = 'assetsAlunosImg';

// Dados brutos dos alunos (apenas filenames)
const studentsData: StudentData[] = [
    { 
        id: 1, 
        name: 'Arthur Nonaka Oda', 
        favoriteQuote: 'We dont need memories', 
        favoriteSong: 'Wave - wave to earth', 
        photo: 'arthur.jpeg',
        githubLink: 'https://github.com/arthur-nonaka',
        linkedinLink: 'https://www.linkedin.com/in/arthur-nonaka-868488292/'
    },
    { 
        id: 2, 
        name: 'Caio Yudi Breetz Okubara', 
        favoriteQuote: 'Tá sentindo a energia', 
        favoriteSong: 'Cor do amor Mc Bdk', 
        photo: 'caio.jpeg',
        githubLink: 'https://github.com/Kaiokrauss',
        linkedinLink: 'https://www.linkedin.com/in/caio-okubara-2815442b6/'
    },
    { 
        id: 3, 
        name: 'Daniel José Dantas Jacometo', 
        favoriteQuote: 'Achievement Unlocked: Criador de Mundos. (Requisito: Transformar uma tela vazia em uma aventura épica usando apenas lógica e criatividade)', 
        favoriteSong: 'Lua de Neon - Takeb feat. Anny', 
        photo: 'daniel.jpeg',
        githubLink: 'https://github.com/DevZIKIII',
        linkedinLink: 'https://www.linkedin.com/in/devziki/'
    },
    { 
        id: 4, 
        name: 'Gabriel Camargo Vieira de Freitas', 
        favoriteQuote: 'Sempre ficamos com lembranças dos erros que cometemos. Que seus erros não sejam um fardo para você, mas sirvam como guias sobre onde não deve seguir.', 
        favoriteSong: 'Ruder Buster - Toby Fox', 
        photo: 'gabriel.jpeg',
        githubLink: 'https://github.com/FreitasCamargo',
        linkedinLink: ''
    },
    { 
        id: 5, 
        name: 'Gustavo Henrique Bispo Costa', 
        favoriteQuote: "That's what she said", 
        favoriteSong: 'Animais - Yunk Vino', 
        photo: 'gustavo.jpeg',
        githubLink: 'https://github.com/GuGuzin14',
        linkedinLink: 'https://www.linkedin.com/in/gustavohenrique5521/'
    },
    { 
        id: 6, 
        name: 'Ian Gabriel de Abreu Barbosa', 
        favoriteQuote: 'O sucesso é a soma de pequenos esforços.', 
        favoriteSong: 'Bohemian Rhapsody', 
        photo: 'ian.jpeg',
        githubLink: 'https://github.com/IanGabs',
        linkedinLink: ''
    },
    { 
        id: 7, 
        name: 'João Pedro Garcia Girotto', 
        favoriteQuote: 'Sempre fui eu mesmo, e isso é o que levo comigo para o próximo capítulo', 
        favoriteSong: 'Aerials - System of A Down', 
        photo: 'joao-girotto.jpeg',
        githubLink: 'https://github.com/JP1005YT',
        linkedinLink: 'https://www.linkedin.com/in/joaogirotto0/'
    },
    { 
        id: 8, 
        name: 'João Pedro Vieira Pereira', 
        favoriteQuote: 'A evolução não se trata do destino, e sim do caminho que se trilha para alcançá-lo', 
        favoriteSong: 'The Chainsmokers - Closer', 
        photo: 'joao-vieira.jpeg',
        githubLink: 'https://github.com/JoaoVieiraZP',
        linkedinLink: 'https://www.linkedin.com/in/jo%C3%A3o-pedro-vieira-pereira-7aab772b1/'
    },
    { 
        id: 9, 
        name: 'João Luiz Souza Pereira', 
        favoriteQuote: 'Deus é bom e o diabo não presta', 
        favoriteSong: 'Jorge da capadócia', 
        photo: 'joao-luiz.jpeg',
        githubLink: 'https://github.com/joaoluiz00',
        linkedinLink: ''
    },
    { 
        id: 10, 
        name: 'João Vitor Trombeta', 
        favoriteQuote: '"The Office, temporada 7, episódio 19, minuto 14:45"', 
        favoriteSong: 'Drown-Bring me the horizon', 
        photo: 'joao-vitor.jpeg',
        githubLink: 'https://github.com/JoaoTrombeta',
        linkedinLink: 'https://www.linkedin.com/in/joao-vitor-trombeta-2654a72b2/'
    },
    { 
        id: 11, 
        name: 'Manoela Pinheiro da Silva', 
        favoriteQuote: 'Aprendi que às vezes a vida também precisa de um try again, catch erros e finally... respirar. Nem toda falha é final. Às vezes, é só um try again.', 
        favoriteSong: '"Try" Colbie Caillat', 
        photo: 'manoela.jpeg',
        githubLink: 'https://github.com/Ma2903',
        linkedinLink: 'https://www.linkedin.com/in/manoela-p-44aa75259/'
    },
    { 
        id: 12, 
        name: 'Matheus Henrique da Conceição Bispo', 
        favoriteQuote: 'Empenho!! Ou Eu sou o melhor!', 
        favoriteSong: 'DtMF - Bad Bunny', 
        photo: 'bispo.jpeg',
        githubLink: 'https://github.com/MatheusHB018',
        linkedinLink: ''
    },
    { 
        id: 13, 
        name: 'Matheus Mendes dos Santos', 
        favoriteQuote: '"Na adversidade, uns desistem, enquanto outros batem recordes." - Ayrton Senna', 
        favoriteSong: 'Hall of Fame – The Script ft. Will.i.am', 
        photo: 'matheus-mendes.jpeg',
        githubLink: 'https://github.com/M3NT0Sz',
        linkedinLink: 'https://www.linkedin.com/in/m3nt0sz/'
    },
    { 
        id: 14, 
        name: 'Matheus William Rodrigues do Nascimento', 
        favoriteQuote: 'Tudo começou com um Hello World, e acabou em ... ERROR 404 Sanity Not Found.', 
        favoriteSong: 'Laços de Redenção - Henrique Mendonça', 
        photo: 'matheus-william.jpg',
        githubLink: 'https://github.com/MatheusWilliam0309',
        linkedinLink: ''
    },
    { 
        id: 15, 
        name: 'Paulo Diney da Silva Martins', 
        favoriteQuote: 'Tudo o que temos de decidir é o que fazer com o tempo que nos é dado.(Gandalf)', 
        favoriteSong: 'My Way - Frank Sinatra', 
        photo: 'paulo.jpeg',
        githubLink: 'https://github.com/PauloDiney',
        linkedinLink: 'https://www.linkedin.com/in/paulo-martins-531519239/'
    },
    { 
        id: 16, 
        name: 'Pedro de Oliveira Muraro', 
        favoriteQuote: 'É necessária uma razão para não querer perder?', 
        favoriteSong: 'Serenata Existencialista - O Grilo', 
        photo: 'pedro.jpeg',
        githubLink: 'https://github.com/Omuraro',
        linkedinLink: 'https://www.linkedin.com/in/pedro-muraro-a362942b5/'
    },
    { 
        id: 17, 
        name: 'Victor Azambuja da Silva', 
        favoriteQuote: 'Não sou tom Jobim mas faço a wave', 
        favoriteSong: 'Vibe de sábado (buja, knbone, Sylva)', 
        photo: 'buja.jpeg',
        githubLink: 'https://github.com/buja23',
        linkedinLink: 'https://www.linkedin.com/in/victor-azambuja-980199370/'
    },
];

// Exporta os alunos com URLs resolvidas
export const students = studentsData.map(student => ({
    ...student,
    // Resolve a URL usando o serviço de imagens
    photo: getImageUrl(STUDENTS_FOLDER, student.photo) || `/assets/${STUDENTS_FOLDER}/${student.photo}`,
}));

// Exporta também os dados brutos para uso em scripts de migração
export { studentsData };